import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';
import { Container } from '../styled/containers';
import { breakpoint } from '../theme/breakpoint';
import { buttonStyles } from '../styled/buttons';

const BannerStyles = css`
  background-color: ${({ theme }) => theme.palette.darkBackground};
  padding: ${({ theme }) => theme.spacing.standard} 0;
`;

export const Banner = styled.div`
  ${BannerStyles};
  visibility: ${({ $visibility }) => ($visibility ? 'hidden' : 'visible')};
`;

export const BannerToStick = styled.div`
  ${BannerStyles};
  border-top: ${({ theme }) => `1px solid ${theme.palette.borderDark}`};
  display: ${({ $bannerStuck }) => ($bannerStuck ? 'block' : 'none')};
  position: fixed;
  bottom: 0;
  width: 100%;
`;

export const StyledContainer = styled(Container)`
  position: relative;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 440px;
  width: 100%;
  margin: 0 auto;
  color: ${({ theme }) => theme.palette.white};

  ${breakpoint.tablet`
    flex-direction: row;
  `}

  > a {
    width: 100%;
    ${breakpoint.tablet`
      width: auto;
    `}
  }
`;

export const TextContain = styled.div`
  margin: ${({ theme }) =>
    `0 ${theme.spacing.standard} ${theme.spacing.standard}`};
  text-align: center;

  ${breakpoint.tablet`
    margin: 0 ${({ theme }) => theme.spacing.standard} 0 0;
    text-align: left;
  `}
`;

export const Title = styled.h4`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-transform: uppercase;
  margin-bottom: 0;
  margin-top: 0;
`;

export const SubTitle = styled.p`
  margin-bottom: 0;
`;

export const Link = styled.a`
  ${buttonStyles};

  &:hover {
    text-decoration: none;
  }
`;

export const Icon = styled(SVG)`
  display: block;
  width: 18px;
  height: 18px;
`;

export const Close = styled.button`
  position: absolute;
  right: ${({ theme }) => theme.spacing.tiny};
  top: 0;
  padding: 4px;
  background: transparent;
  border: none;
  line-height: 1;
  font-size: ${({ theme }) => theme.fontsize.larger};

  ${Icon} {
    color: ${({ theme }) => theme.palette.white};
  }

  &:focus,
  &:hover {
    ${Icon} {
      color: ${({ theme }) => theme.palette.linkHoverOnDarkBG};
    }
  }
`;
